export default __webpack_public_path__ + "static/media/Me4.0076659d.png";